module.exports = {
  name: 'Nick @Rushnett',
  img: 'img/theme/pixel-cat.jpg',
  location: 'USA',
  occupation: 'Software Developer/Student',
  degree: 'BS in Computer Science',
  about: '&nbsp; I\'m not quite sure what to write here, but I do a lot of different work in the computer science world. I love to make applications and UI, and have a strong interest in tinkering with new things. I make a lot of small projects that never see the light of day, but every now and then I make something interesting and release it to the world (like watchpls).<br><br>If you like my work, be sure to follow my github and contribute!<br><br>...and if you like my art, follow my twitter and force me to post it.',
  twitter: 'https://twitter.com/rushnett',
  stats: [
    {
      title: 'Cats',
      value: '1'
    },
  ]
}